<template>
  <div class="tabSection">
    <div class="btn-group btn-group-toggle video-buttons" data-toggle="buttons">
      <label class="btn btn-primary">
        <input
          @click="switchVideo('/stream?topic=/automato/rover/front_color_depth')"
          type="radio"
          name="options"
          id="option1"
          autocomplete="off"
        />
        {{ $t("global.front")}}
      </label>
      <label class="btn btn-primary">
        <input
          @click="switchVideo('/stream?topic=/automato/rover/back_color_depth')"
          type="radio"
          name="options"
          id="option2"
          autocomplete="off"
        />
        {{ $t("global.back")}}
      </label>
      <label class="btn btn-primary">
        <input
          @click="switchVideo('/stream?topic=/automato/rover/side_color_depth')"
          type="radio"
          name="options"
          id="option3"
          autocomplete="off"
        />
        {{ $t("global.side")}}
      </label>
    </div>
    <div class="video-player" v-if="this.selectedVideo">
      <img class="video" :src="this.selectedVideo" />
    </div>
    <div v-else class="no-video row d-flex justify-content-center">
      <i class="material-icons">videocam_off</i>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";

export default {
  name: "VideoPanel",
  mounted() {
    this.switchVideo("/stream?topic=/automato/rover/front_color_depth");
  },
  computed: mapState({
    selectedVideo: state => state.selectedVideo
  }),
  methods: {
    switchVideo(path) {
      let url = null;
      if (path != null) {
        url = process.env.VUE_APP_VIDEO_SERVER_URL_BASE + path;
      }
      this.$store.dispatch("switchVideo", url);
    }
  }
};
</script>

<style scoped>
.video-buttons {
  width: 100%;
}
.no-video i {
  font-size: 148px;
}
</style>